import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { Success, Error_ } from "ui-components/Alert";
import { formRender, initialValues, shippingZoneValidation } from "./shipping-zone-schema";
import ShippingZoneInfo from "./components/ShippingZoneInfo";
import { useLocation } from "react-router-dom";
import { editShippingZone } from "services/data.internal.service";
import { getShippingZone } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";

function EditShippingZone() {
  const location = useLocation();
  const { shippingZone } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["shipping-zone", { shippingZone }],
    queryFn: () => getShippingZone({ shippingZone }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editShippingZoneMutation = useMutation(editShippingZone, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(shippingZoneValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    formRender,
  };
  const onSubmit = (data) => {
    editShippingZoneMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["shipping-zone"]),
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ShippingZoneInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty} url="/setup/shipping-zone" />
      </form>
    </Layout>
  );
}

export default EditShippingZone;
